import strings from 'strings';
import { SvgCheck } from 'UI/res';

import { formatDateTime } from './profileFormatters';

const COPIES = strings.inventoryProfiles.common;

/**
 * Summary labels (`[{ title, content, icon? }]`). ProfileSummary hands them to EntitySummary,
 * which drops the ones without content, so these return an item even when the value is empty.
 */

/**
 * @param {Array<{ created_at: string }>} [referenceReleases] Newest first, as V1 reads them
 */
export const buildReferenceReleaseDetail = (referenceReleases = []) => {
  const lastEmailSent = referenceReleases[0];

  return {
    title: COPIES.referenceRelease,
    icon: lastEmailSent ? SvgCheck : undefined,
    content: lastEmailSent
      ? strings.formatString(COPIES.referenceReleaseSent, {
          date: formatDateTime(lastEmailSent.created_at)
        })
      : COPIES.referenceReleaseNotSent
  };
};

/**
 * @param {{ optOutStatus?: { optOut?: boolean, createdAt?: string } }} profile
 */
export const buildOptOutDetail = profile => ({
  title: COPIES.optOut.creation,
  content: profile?.optOutStatus?.optOut ? formatDateTime(profile.optOutStatus.createdAt) : ''
});

/**
 * @param {string | null} [lastPayment] UTC date of the last payment of a company
 */
export const buildLastPaymentDetail = lastPayment => ({
  title: COPIES.lastPayment,
  content: formatDateTime(lastPayment)
});

/**
 * @param {{ personalInformation?: { full_name?: string }, legal_name?: string } | null} [recruiter]
 */
export const buildRecruiterDetail = recruiter => ({
  title: COPIES.recruiterLabel,
  content: recruiter?.personalInformation?.full_name || recruiter?.legal_name || ''
});
